const state = {
    sm_product_types: [],
    sm_product_type: {},
    sm_product_type_filters: {},
}

export default state;
